import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { authApi } from '../../api/auth.api'
import { useAuthStore } from '../../stores/authStore'

/** Signs this browser out: shared by the top bar's account menu and the side menu's More. */
export function useSignOut(): () => void {
  const navigate = useNavigate()
  const logout = useAuthStore((s) => s.logout)
  const queryClient = useQueryClient()

  return () => {
    // Revoke server-side first, but never block the sign-out on it: a refresh
    // token discarded only in localStorage stays usable until it expires, and
    // a failed call is no reason to keep someone signed in.
    const { refreshToken } = useAuthStore.getState()
    if (refreshToken) {
      void authApi.logout(refreshToken).catch(() => {})
    }
    logout()
    queryClient.clear()
    navigate('/login')
  }
}
